<div class="sidebar-container" [class.collapsed]="isCollapsed()">

  <!-- LOGO SECTION -->
  <div class="logo-section">
    <img src="assets/toro.png" alt="Toro Logo" class="toro-logo" />
    <span class="oasis-text" [class.hidden]="isCollapsed()">OASIS</span>
    <span class="beta-badge" [class.hidden]="isCollapsed()">(BETA)</span>
  </div>

  <!-- MENU ITEMS -->

  <!-- DASHBOARD -->
  <a routerLink="/dashboard" routerLinkActive="active"
    class="nav-item flex items-center gap-2 p-3 rounded hover:bg-gray-700 cursor-pointer"
    [class.opacity-50]="loading()"
    [class.cursor-not-allowed]="loading()"
    [title]="isCollapsed() ? 'Dashboard' : ''"
    [attr.aria-disabled]="!hasIdentity() ? 'true' : null"
    (click)="onProtectedClick($event, hasIdentity())">
    <img src="assets/icons/dashboard.png" class="h-6 w-6 nav-img-white" alt="dashboard-icon">
    <span [class.hidden]="isCollapsed()">Dashboard</span>
  </a>


  <nav class="sidebar">
    <ul class="menu space-y-1">

      <!-- Device -->
      <li class="menu-item">
        <!-- Device (clickable toggle, like Utility) -->
        <div class="has-tooltip">
          <a (click)="toggleSubmenu('device')"
            class="nav-item flex items-center gap-2 p-3 rounded cursor-pointer hover:bg-gray-700"
            [class.opacity-50]="loading()"
            [class.cursor-not-allowed]="loading()"
            aria-describedby="device-tooltip"
            [title]="isCollapsed() ? 'Device' : ''"
            [attr.aria-disabled]="!hasIdentity() ? 'true' : null">
            <img src="assets/icons/device.png" class="h-6 w-6 nav-img-white" alt="device-icon">
            <span [class.hidden]="isCollapsed()">Device</span>
          </a>

          <!-- Hover tooltip -->
          <span id="device-tooltip" role="tooltip" class="tooltip">
            Device Properties
          </span>
        </div>

        <!-- Submenu for Device -->
      <ul class="submenu" [class.hidden]="!showDeviceSubmenu()" [class.collapsed]="isCollapsed()">

          <!-- Device Identity -->
          <li *ngIf="!isDisconnected()">
            <a routerLink="/device/device-identity" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [class.opacity-50]="loading()"
              [class.cursor-not-allowed]="loading()"
              [title]="isCollapsed() ? 'Device Identity' : ''"
              [attr.aria-disabled]="!hasIdentity() ? 'true' : null">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span [class.hidden]="isCollapsed()">Device Identity</span>
            </a>
          </li>

          <!-- Device Twin -->
          <li>
            <a routerLink="/device/device-twin" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [title]="isCollapsed() ? 'Device Twin' : ''">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
              <span [class.hidden]="isCollapsed()">Device Twin</span>
            </a>
          </li>

          <!-- Telemetry -->
          <li *ngIf="!isDisconnected()">
            <a routerLink="/device/telemetry" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [title]="isCollapsed() ? 'Telemetry' : ''">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
              <span [class.hidden]="isCollapsed()">Telemetry</span>
            </a>
          </li>

          <!-- Direct Method -->
          <li *ngIf="!isDisconnected()">
            <a routerLink="/device/direct-method" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [class.opacity-50]="loading()"
              [class.cursor-not-allowed]="loading()"
              [title]="isCollapsed() ? 'Direct Method' : ''"
              [attr.aria-disabled]="!hasIdentity() ? 'true' : null">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              <span [class.hidden]="isCollapsed()">Direct Method</span>
            </a>
          </li>

          <!-- Cloud-to-device Message -->
          <li *ngIf="!isDisconnected()">
            <a routerLink="/device/cloud-to-device-message" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [class.opacity-50]="loading()"
              [class.cursor-not-allowed]="loading()"
              [title]="isCollapsed() ? 'Cloud-to-device Message' : ''"
              [attr.aria-disabled]="!hasIdentity() ? 'true' : null">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 2L11 13"></path>
                <path d="M22 2l-7 20-4-9-9-4 20-7z"></path>
              </svg>
              <span [class.hidden]="isCollapsed()">Cloud-to-device Message</span>
            </a>
          </li>
        </ul>

      <!-- Server -->
      <li class="menu-item">
        <!-- Server Logs (clickable toggle, like Utility) -->
        <div class="has-tooltip">
          <a (click)="toggleSubmenu('server')"
            class="nav-item flex items-center gap-2 p-3 rounded cursor-pointer hover:bg-gray-700"
            [class.opacity-50]="loading()"
            [class.cursor-not-allowed]="loading()"
            aria-describedby="server-tooltip"
            [title]="isCollapsed() ? 'Server Logs' : ''"
            [attr.aria-disabled]="!hasIdentity() ? 'true' : null">
            <img src="assets/icons/server.png" class="h-5 w-5" alt="server-icon">
            <span [class.hidden]="isCollapsed()">Server Logs</span>
          </a>

          <!-- Hover tooltip -->
          <span id="server-tooltip" role="tooltip" class="tooltip">
            Server messages and notifications
          </span>
        </div>

        <!-- Submenu for Server -->
        <ul class="submenu" [class.hidden]="!isServerAvailable()" [class.collapsed]="isCollapsed()">

          <!-- Message -->
          <li>
            <a routerLink="/server/message" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [title]="isCollapsed() ? 'Message' : ''">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
              <span [class.hidden]="isCollapsed()">Message</span>
            </a>
          </li>

          <!-- User Notification -->
          <li>
            <a routerLink="/server/user-notification" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [title]="isCollapsed() ? 'User Notification' : ''">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
              <span [class.hidden]="isCollapsed()">User Notification</span>
            </a>
          </li>

          <!-- Exceptions -->
          <li>
            <a routerLink="/server/exceptions" routerLinkActive="active"
              [queryParams]="deviceRouteQueryParams()"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [title]="isCollapsed() ? 'Exceptions' : ''">
              <svg class="submenu-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <span [class.hidden]="isCollapsed()">Exceptions</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Tools Section -->
      <li class="menu-item">
        <!-- Tools (clickable to expand/collapse submenu) -->
        <div class="has-tooltip">
          <a (click)="toggleToolsMenu()" class="nav-item flex items-center gap-2 p-3 rounded cursor-pointer hover:bg-gray-700"
            aria-describedby="tools-tooltip"
            [title]="isCollapsed() ? 'Utility' : ''">
            <span class="icon" style="font-size: 1.5em">⚙️</span>
            <span [class.hidden]="isCollapsed()">Utility</span>
          </a>

          <!-- Hover tooltip -->
          <span id="tools-tooltip" role="tooltip" class="tooltip">
            Encrypt and decrypt payloads
          </span>
        </div>

        <!-- Submenu for Tools -->
        <ul class="submenu" [class.hidden]="!showToolsMenu()" [class.collapsed]="isCollapsed()">
          <li>
            <a routerLink="/crypto/encrypt" routerLinkActive="active"
              class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [title]="isCollapsed() ? 'Encrypt' : ''">
              <span class="icon">🔒</span>
              <span [class.hidden]="isCollapsed()">Encrypt</span>
            </a>
          </li>
          <li>
            <a routerLink="/crypto/decrypt" routerLinkActive="active"
               class="nav-item block px-3 py-2 rounded cursor-pointer flex items-center gap-2 hover:bg-gray-700"
              [title]="isCollapsed() ? 'Decrypt' : ''">
              <span class="icon">🔓</span>
              <span [class.hidden]="isCollapsed()">Decrypt</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>

    <!-- HELP -->
    <a routerLink="/help" routerLinkActive="active"
      class="nav-item flex items-center gap-2 p-3 rounded hover:bg-gray-700 cursor-pointer"
      [title]="isCollapsed() ? 'Help' : ''">
      <img src="assets/icons/help.png" class="h-6 w-6 nav-img-white" alt="help-icon">
      <span [class.hidden]="isCollapsed()">Help</span>
    </a>

  </nav>

  <!-- Hide/Show Menu Toggle - Fixed at bottom -->
  <div class="toggle-bottom" (click)="toggleSidebar()" [title]="isCollapsed() ? 'Show Menu' : ''">
    @if (isCollapsed()) {
      <span class="toggle-arrow">→</span>
    } @else {
      <span class="toggle-arrow">←</span>
      <span class="toggle-text">Hide Menu</span>
    }
  </div>

</div>